'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmPhone = undefined;

var _ConfirmPhone2 = require('./ConfirmPhone');

var _ConfirmPhone3 = _interopRequireDefault(_ConfirmPhone2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfirmPhone = _ConfirmPhone3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmPhone/index.js
// module id = 1654
// module chunks = 0